import React, { useEffect, useState } from "react";
import Map from "ol/Map.js";
import View from "ol/View.js";
import * as proj from "ol/proj";
import "ol/ol.css";
import {
  defaults as defaultInteractions,
  DragRotateAndZoom
} from "ol/interaction";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { Vector as VectorLayer } from "ol/layer";
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature.js";
import Point from "ol/geom/Point.js";
import { Cluster } from "ol/source.js";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style.js";
import { useSelector } from "react-redux";

export default function DashboardMap() {
  const [center, setCenter] = useState(proj.fromLonLat([44.3661, 33.3152]));
  const [zoom, setZoom] = useState(6);
  const pointsArr = useSelector(state => state.cardsReducer.locArr);
  let features = [];

  pointsArr.map(el => {
    return features.push(new Feature(new Point(proj.fromLonLat(el))));
  });
  var source = new VectorSource({
    features: features
  });

  var clusterSource = new Cluster({
    distance: 20,
    source: source
  });

  var styleCache = {};
  var clusters = new VectorLayer({
    source: clusterSource,
    style: function(feature) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        style = new Style({
          image: new CircleStyle({
            radius: 10,
            stroke: new Stroke({
              color: "#fff"
            }),
            fill: new Fill({
              color: "#3399CC"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
        styleCache[size] = style;
      }
      return style;
    }
  });
  var raster = new TileLayer({
    source: new OSM()
  });
  // const baghdad = proj.fromLonLat([44.3661, 33.3152]);
  const map = new Map({
    interactions: defaultInteractions().extend([new DragRotateAndZoom()]),

    target: null,
    layers: [],

    view: new View({
      center: center,
      zoom: zoom,
      minZoom: zoom
    })
  });
  useEffect(() => {
    map.setTarget("map");
    pointsArr.map(el => {
      return features.push(new Feature(new Point(el)));
    });

    map.addLayer(raster);

    map.addLayer(clusters);

    // Listen to map changes
    map.on("moveend", () => {
      let center = map.getView().getCenter();
      let zoom = map.getView().getZoom();
      setCenter(center);
      setZoom(zoom);
    });
    return () => {
      map.setTarget(null);
    };
  }, [pointsArr]);

  return (
    <div>
      <div id="dashboardMap">
        <div id="map" style={{ width: "100%", height: "575px" }} />
        <div className="blue-circle" id="overlay" title="overlay"></div>
      </div>
    </div>
  );
}
